import React from 'react';
import { Model as PurramidNightsEditor } from '../ff037-purry-nights';

// Own model entry; reuse the editor with this model's authoritative configuration.
export const Model = ({ modelId }: { modelId: string }) => (
  <PurramidNightsEditor key={modelId} modelId={modelId} />
);

export default Model;
